export const SET_PROPERTIES = 'SET_PROPERTIES';

export const propertiesActions = {
  setProperties: (properties) => ({
    type: SET_PROPERTIES,
    payload: properties
  })
};
